exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".booking .ant-descriptions.ant-descriptions-bordered {\n  margin: 10px;\n}\n", ""]);

